export const home = {
  home_profile_selector_text: 'اختر ملفًا شخصيًا',
  home_profile_selector_subtitle: 'اختر ملفك الشخصي لمتابعة تسجيلك.',
  home_has_account_true: 'لا، أنا أشارك بالفعل',
  home_has_account_false: 'نعم، أنضم إلى الدراسة!',
  home_is_new: 'هل أنت جديد؟',
  // مذكرة المعلومات العامة: وثيقة مرجعية للقراءة، وليست شروطًا يقبلها الزائر بالتسجيل
  // (الوثيقة التي تُقبل هي الموافقة، في نهاية التسجيل).
  // ملاحظة: الصفحة الرئيسية لا تتعامل مع اتجاه النص اليوم، وهذه أول جملة فيها برابط
  // مضمَّن — لذلك تبقى جملة واحدة بسيطة بلا علامات ترقيم في الطرفين تنقلب في العرض.
  home_study_notice_prefix: 'دراسة بحثية',
  home_study_notice_link: 'اقرأ مذكرة المعلومات',
  home_study_notice_title: 'مذكرة المعلومات',
  home_study_notice_reference: 'هذه الوثيقة مقدمة للعلم فقط. أما الوثيقة التي ستوافق عليها فستُعرض عليك في نهاية التسجيل، قبل الموافقة.',
  home_study_notice_error: 'مذكرة المعلومات غير متاحة في الوقت الحالي.',
  home_forgot_password: 'هل نسيت كلمة المرور؟',
  home_inscription_title: 'التسجيل',
  home_consent_title: 'الموافقة',
  home_consent_expired_title: 'انتهت صلاحية صفحة الموافقة هذه',
  home_consent_expired_description: 'بقيت هذه الصفحة مفتوحة لفترة طويلة. ارجع إلى الخطوة السابقة لتحميل الموافقة من جديد ومتابعة تسجيلك.',
  home_consent_item_required: 'إلزامي',
  home_consent_item_optional: 'اختياري',
  home_consent_items_mismatch: 'تم تحديث الموافقة. يرجى مراجعة الخانات وتأكيدها من جديد.',
  home_consent_item_accept: 'أوافق',
  home_consent_item_refuse: 'أرفض',
  home_consent_grant_conflict: 'قام الفريق للتو بتسجيل موافقة. يرجى التأكيد من جديد.',
  home_content_check_text: 'بتحديد هذه الخانة، أؤكد أنني أوافق على جميع شروط وثيقة المعلومات',
  home_content_none_text: 'بدون موافقة',
  home_not_consent_text: 'لا أوافق على جميع الشروط',
  home_content_signature_text: 'وقع أدناه لتقديم موافقتك',
  home_inclusion_placeholder: 'اختر واحدًا',
  home_inclusion_answer_true: 'نعم',
  home_inclusion_answer_false: 'لا',
  home_inclusion_on: 'حولك',
  home_inclusion_off: 'لا سؤال حول الإدراج',
  home_identifier_title: 'اختر معرفك',
  home_contact_title: 'الاتصال بك',
  home_contact_description: 'لكي تعمل الدراسة، ستتلقى تذكيرات ومعلومات تصل إلى مرتين في الشهر.',
  home_inscription_identifier: 'البريد الإلكتروني أو اللقب',
  home_inscription_firstname: 'الاسم الأول',
  home_inscription_lastname: 'اسم العائلة',
  home_inscription_nickname: 'اللقب',
  home_inscription_email: 'البريد الإلكتروني',
  home_inscription_phone: 'الهاتف',
  home_inscription_external_id: 'رقم الملف',
  home_inscription_address: 'العنوان',
  home_inscription_birthdate: 'تاريخ الميلاد',
  home_inscription_off: 'بدون تعريف',
  home_secret_questions: 'الأسئلة السرية',
  home_secret_question_date_placeholder: 'اختر تاريخًا',
  home_secret_question_number_placeholder: 'أدخل الرقم',
  home_secret_question_text_placeholder: 'أدخل النص',
  home_password_title: 'أنشئ كلمة المرور الخاصة بك',
  home_password_placeholder: 'كلمة المرور',
  home_password_placeholder_confirm: 'تأكيد كلمة المرور',
  home_login_email_placeholder: 'البريد الإلكتروني',
  home_login_nickname_placeholder: 'اللقب أو البريد الإلكتروني أو الهاتف',
  home_login_identifier_placeholder: 'اللقب أو البريد الإلكتروني أو الهاتف أو رقم الملف',
  home_login_file_placeholder: 'أدخل رقم الملف',
  home_password_description: 'يجب أن تكون كلمة المرور بطول 8 أحرف على الأقل وتحتوي على أحرف كبيرة وصغيرة ورموز وأرقام.',
  home_login_title: 'تسجيل الدخول',
  home_login_subtitle: 'سعيد برؤيتك مرة أخرى!',
  home_login_incorrect: 'اسم المستخدم أو كلمة المرور غير صحيحة.',
  home_login_too_many_attempts: 'محاولات تسجيل دخول كثيرة جدًا. لأمانك، يُرجى الانتظار بضع دقائق قبل المحاولة مرة أخرى.',
  home_login_button: 'تسجيل الدخول',
  home_login_password_placeholder: 'كلمة المرور الخاصة بك',
  home_stratification_title: '',
  home_stratification_placeholder: 'اختر واحدًا',
  home_sites_text: 'الانتماء إلى الموقع',
  home_subsites_text: 'الانتماء إلى الفرع',
  home_do_you_have_account: 'هل لديك حساب؟',
  home_researchers_website: 'موقع الباحثين',
  home_registred_successfully: 'تهانينا، تم تسجيلك بنجاح.',
  home_inscription_error_EMAIL_EXIST: 'يوجد حساب بهذا البريد الإلكتروني بالفعل',
  home_inscription_error_NICKNAME_EXIST: 'يوجد حساب بهذا اللقب بالفعل',
  home_inscription_error_EXTERNAL_ID_UNKNOWN: 'رقم الملف غير معروف — تحقق من الرقم الذي سلمه لك الفريق',
  home_family_title: 'عائلتك',
  home_family_count_fallback: 'كم عدد «{{role}}» في عائلتك؟',
  home_family_absence_fallback: 'هل يوجد «{{role}}» في ملفك؟',
  home_inscription_contact_verification_description: 'أدخل رموز التحقق المكونة من 6 أرقام التي أرسلناها لتأكيد بيانات الاتصال الخاصة بك.',
  home_inscription_contact_verified: 'تم التحقق',
  home_inscription_contact_verification_success: 'تم التحقق من بيانات الاتصال الخاصة بك.',
  home_inscription_email_verification_request_error: 'حدث خطأ أثناء إرسال رمز التحقق عبر البريد الإلكتروني',
  home_inscription_email_verification_error: 'حدث خطأ أثناء التحقق من رمز البريد الإلكتروني',
  home_inscription_phone_verification_request_error: 'حدث خطأ أثناء إرسال رمز التحقق عبر الرسائل النصية',
  home_inscription_phone_verification_error: 'حدث خطأ أثناء التحقق من رمز الرسائل النصية',

  // Randomisation errors
  home_randomisation_no_slots: 'التسجيل ممتلئ حاليًا لمجموعتك. يرجى المحاولة لاحقًا أو الاتصال بفريق الدراسة.',
  home_randomisation_no_matching_group: 'لا توجد مجموعة عشوائية تطابق ملفك الشخصي. يرجى الاتصال بفريق الدراسة.',
  home_randomisation_invalid_case_code: 'لم يتم العثور على رقم الملف هذا. يرجى التحقق منه والمحاولة مرة أخرى.',
  home_randomisation_unsupported: 'تستخدم هذه الدراسة طريقة تسجيل غير مدعومة بعد. يرجى الاتصال بفريق الدراسة.',
  home_randomisation_site_required: 'يرجى اختيار موقعك قبل إعطاء موافقتك.',

  // Case code step
  home_case_code_title: 'رقم الملف',
  home_case_code_description: 'أدخل رقم الملف الذي تم منحه لك.',
  home_case_code_placeholder: 'رقم الملف',

  // إضافة Synakene
  home_welcome: "مرحبًا بك في {{appName}}!",
  home_description: "قيّم حالتك مع {{appName}}!",
  home_partners_caption: "بدعم من",
  home_anonymous_data: "بياناتك سرية؛ لن يتمكن الباحثون من الوصول إلى هويتك.",
  home_new: "هل أنت جديد؟",
  home_copy_link: "انسخ رابط الدراسة",
  home_copied: "تم نسخ الرابط بنجاح!",
  not_eligible_but_try_the_app: "لا، ليس لدي بين 11 و 24 عامًا، ولكن أود اكتشاف التطبيق",

  home_not_included: "شكرًا لاهتمامك، ولكن يجب أن تكون بين 11 و 24 عامًا وتعيش في فرنسا.",
  home_not_included_desc: "لمساعدتنا، يمكنك مشاركة الدراسة مع من حولك.",
  home_nir_title: 'Your social security number',
  home_nir_explanation_snds: 'Used solely to link the study with the national health data system (SNDS). Encrypted, stored separately, never visible to the research team.',
  home_nir_placeholder: '15 digits, as printed on your carte Vitale',
  home_nir_input_placeholder: 'e.g. 2 85 05 78 006 048 22',
  home_nir_field_label: 'Social security number (NIR)',
  home_nir_optional_label: 'Optional',
  home_nir_error_conflict: 'This social security number is already linked to another participant of this study.',
  home_nir_holder_birthdate_label: 'Your date of birth',
  home_nir_holder_birthdate_hint: 'Day, month and year, as shown on your ID',
  home_nir_holder_birthdate_readback: 'Date entered: {{date}}',
  home_nir_error_opposed: 'You have objected to the use of your social security number: it can no longer be recorded. Leave the field empty to continue.',
  home_nir_holder_birthdate_explanation: 'Your date of birth is asked together with your number to link your own care data to the study. It is encrypted, stored separately with your number, and deleted with it after the transmission.',
};
